import styled from 'styled-components'
import {
  communicationButtonCss,
  communicationContentWrapperCss,
  communicationImageWrapperCss,
  communicationRootCss,
  communicationTitleCss,
} from '~/pages/communication/libs/communicationBaseStyles'

export const InfoPageStyles = {
  Root: styled.div`
    ${communicationRootCss}
  `,

  ContentWrapper: styled.div<{ $gap?: number }>`
    ${communicationContentWrapperCss}
    ${({ $gap }) => $gap !== undefined && `gap: ${$gap}px;`}
  `,

  Title: styled.h1`
    ${communicationTitleCss}
  `,

  ImageWrapper: styled.div<{ $withFade?: boolean }>`
    ${communicationImageWrapperCss}
    ${({ $withFade }) =>
      $withFade &&
      `
      position: relative;
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 40px;
        background: linear-gradient(to bottom, transparent, #fff);
        pointer-events: none;
      }
    `}
  `,

  Subtitle: styled.p`
    font-size: 15px;
    font-weight: 400;
    line-height: 1.5;
    text-align: center;
    color: #17202a;

    strong {
      font-weight: 700;
    }
  `,

  Button: styled.button`
    ${communicationButtonCss}
    margin-top: auto;
  `,
}
